import ProfileIcon from "../../../assets/images/ProfileIcon";
import {
  ConfirmationDialog,
  Constants,
  DashboardConstants,
  StaffListConstants,
  StafflistConstants,
  UserStatus,
  UserStatusAction,
  UserValidationStatus,
  pageRouteConstants,
} from "../../../constants/constants";
import "./Staflist.css";
import SearchBar from "../../common/SearchBar";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store/store";
import { fetchStaffListAsync } from "../../../store/thunks/staffListThunk";
import { updateUserStatusAsync } from "../../../store/thunks/userThunk";
import {
  resetUpdateStatusErrorMsg,
  resetStatus,
  validatePendingStaffData,
} from "../../../store/slices/validatePendingStaffSlice";
import {
  ApplicationInfo,
  EKYCStatus,
  STATUS,
  resetCameraError,
  resetDeativateStatus,
  resetUserStatus,
} from "../../../store/slices/userDetailslice";
import PopupModal from "../../common/PopupModal";
import PopupModalWithCancelButton from "../../common/PopupModalWithCancelButton";
import ApproveIcon from "../../../assets/images/ApproveIcon";
import RejectIcon from "../../../assets/images/RejectIcon";
import DeactivateIcon from "../../../assets/images/DeactivateIcon";
import { formatDate, getFormattedDate } from "../../../utils/DataTime";
import Loader from "../../common/styles/Loader";
import DownloadBar from "../../common/DownloadBar";
import FilterBar from "../../common/FilterBar";
import SortBar from "../../common/SortBar";
import StaffListDropDownIcon from "../../../assets/images/StaffListDropDownIcon";
import AddIcon from "../../../assets/images/AddIcon";
import LoaderPopupModel from "../../common/LoaderPopup";
import { saveActiveTabIndex } from "../../../store/slices/rolesSlice";
import TooltipIcon from "../../../assets/images/TooltipIcon";
import {
  readFromLocalStorage,
  writeToLocalStorage,
} from "../../../utils/DataEncryption";
import { getUserValidationStatus } from "../../common/UserValidation";
import { PopUpModelForStaffExitFlow } from "../../common/PopUpModelForStaffExitFlow";
import StaffListAndroid from "./StaffListAndroid";
import StaffListPopups from "./StaffListPopups";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { current } from "@reduxjs/toolkit";
export interface UserStatusRequestObj {
  status: string;
  userId: string;
}
export const statusClassMap: Record<string, string> = {
  ACTIVE: "bg-activeButtonColor",
  INACTIVE: "bg-sideMenuHelpBox",
  PASSIVE: "bg-passiveColor",
  PENDING_ACTIVE: "bg-pendingButtonColor", // default if status doesn't match
};
export const userStatus: any = {
  PENDING_ACTIVE: "Pending",
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  PASSIVE: "Passive",
};
export const statusMap: Record<string, string> = {
  ACTIVE: t("ActiveStaff"),
  PENDING_ACTIVE: t("PendingStaff"),
};
const StaffListComponent = ({ statusKey }: any) => {
  const { t, i18n } = useTranslation();
  const [popUpMsg, setPopUpMsg] = useState("");
  const [userStatusObj, setUserStatusObj] =
    useState<UserStatusRequestObj | null>(null);
  const currentUrl = window.location.href;
  const routeUrl = currentUrl.split("#/");

  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState<string | number>(1);
  const [showApprovedPopUp, setShowApprovedPopUp] = useState(false);
  const [show, setShow] = useState(false);
  const [approveButtonClicked, setApproveButtonClicked] = useState(false);
  const [rejectButtonClicked, setRejectButtonClicked] = useState(false);
  const [errorMsgStatus, setErrorMsgStatus] = useState(true);
  const [rowsPerPageValue, setRowsPerPageValue] = useState(10);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [pageNumber, setPageNumber] = useState("0");
  const [selectedExitFlowMethod, setSelectedExitFLowMethod] = useState(0);
  const [showDeActivateOptions, setShowDeActivateOptions] = useState(false);

  const rowPerPageArray = [10, 20, 30];

  const staffList: any = useSelector((state: RootState) => state.staffListData);
  const [staffListData, setStaffListData] = useState(staffList);

  const totalCount = staffList?.staffList?.totalCount;
  const totalPages = Math.ceil(totalCount / rowsPerPageValue);
  const pendingStaff: validatePendingStaffData = useSelector(
    (state: RootState) => state.validatePendingStaffData
  );
  const updateStatus: string = useSelector(
    (state: RootState) => state.validatePendingStaffData.updateStatus
  );
  const errorMsg = useSelector(
    (state: RootState) => state.validatePendingStaffData.updateStatusErrorMsg
  );
  const errorDeleteMsg = useSelector(
    (state: RootState) => state.userDetails.deleteErrorMsg
  );

  const [deleteUserId, setDeleteUserId] = useState("");
  const deleteUserStatus = useSelector(
    (state: RootState) => state.userDetails.deleteUserStatus
  );
  const [selectedUserId, setSelectedUserId] = useState("");

  const updateUserStatus = async (status: string, userId: string) => {
    if (status == "ACCEPT") {
      setApproveButtonClicked(true);
      setPopUpMsg(t("approveUser"));
    } else if (status === UserStatusAction.ACTIVATE) {
      setApproveButtonClicked(true);
      setPopUpMsg(t("activateUser"));
    } else {
      setRejectButtonClicked(true);
      setPopUpMsg(t("rejectUser"));
    }
    setShow(true);
    setUserStatusObj({ status, userId });
  };
const [isStaffListPage, setIsStaffListPage] = useState(false);
  useEffect(() => {
     setIsStaffListPage(window.location.hash.includes('staffList'));
  }, []);

  useEffect(() => {
    if(currentPage !== ""){
    dispatch(
      fetchStaffListAsync({
        pageNumber: Number(currentPage) - 1,
        rowsPerPage: rowsPerPageValue,
        key: statusKey,
      })
    );
    dispatch(saveActiveTabIndex(0));
  }
  }, [dispatch, rowsPerPageValue, currentPage]);

  useEffect(() => {
    setStaffListData(staffList);
    console.log(staffList, "staffList");
  }, [staffList]);

  const rejectUser = async () => {
    setPopUpMsg(t("RejectedSuccessMessage"));
    setShow(false);
    await dispatch(updateUserStatusAsync(userStatusObj));
  };

  const approveUser = async () => {
    if (userStatusObj?.status === UserStatusAction.ACTIVATE) {
      setPopUpMsg(t("ActivatedSuccessMessage"));
    } else {
      setPopUpMsg(t("ApprovedSuccessMessage"));
    }
    setShow(false);
    await dispatch(updateUserStatusAsync(userStatusObj));
  };

  useEffect(() => {
    if (deleteUserStatus === STATUS.SUCCESS) {
      setShowApprovedPopUp(true);
    }
    if (deleteUserStatus === STATUS.FAILED) {
      setPopUpMsg(t("APIErrorMessage"));
      setShowApprovedPopUp(true);
    }
  }, [deleteUserStatus, pageNumber, rowsPerPageValue, currentPage]);
  useEffect(() => {
    if (updateStatus == STATUS.SUCCESS) {
      setShowApprovedPopUp(true);
    }
    if (updateStatus == STATUS.FAILED) {
      setPopUpMsg(t("APIErrorMessage"));
      setShowApprovedPopUp(true);
    }
  }, [updateStatus, dispatch, pageNumber, rowsPerPageValue, currentPage]);

  const handleNextPage = () => {
    if (Number(currentPage) < totalPages) {
      setCurrentPage(Number(currentPage) + 1);
    }
  };

  const handlePrevPage = () => {
    if (Number(currentPage) > 1) {
      setCurrentPage(Number(currentPage) - 1);
    }
  };
  const closeModal = () => {
    setShowApprovedPopUp(false);
    setPopUpMsg("");
    setRejectButtonClicked(false);
    setApproveButtonClicked(false);
    dispatch(resetStatus());
    dispatch(resetUserStatus());
    dispatch(resetUpdateStatusErrorMsg());
    dispatch(resetDeativateStatus());
  };

  const handelRowsPerPagechange = (e: any) => {
    setCurrentPage(1);
    setRowsPerPageValue(e.target.value);
  };

  const divRef = useRef<HTMLDivElement>(null);

useEffect(() => {
  if (divRef.current && divRef.current.innerText !== String(currentPage)) {
    divRef.current.innerText = String(currentPage);
  }
}, [currentPage]);

const handlePageNumberChange = (e: any) => {
  const value = e.target.value;

  // allow clearing
  if (value === "") {
    setCurrentPage("");   // allow empty temporarily
    setShowErrorMessage(false);
    return;
  }

  // convert to number
  const num = Number(value);
  if (!isNaN(num) && num <= totalPages) {
    setShowErrorMessage(false);
    setCurrentPage(num);
  } else {
    setShowErrorMessage(true);
  }
};


  const isEkycVerified = (
    ekycStatus: EKYCStatus,
    consentStatus: any,
    isEkycEnabled: boolean
  ) => {
    if (
      isEkycEnabled === false ||
      (consentStatus === true &&
        (ekycStatus?.pan === true ||
          ekycStatus?.drivingLicense === true ||
          ekycStatus?.bank === true))
    ) {
      return true;
    }
  };

  const handleDeactivateButton = (userId: string) => {
    console.log("isnide");
    setShowDeActivateOptions(true);
    setSelectedUserId(userId);
  };
  const OnExitFlowPopUpContinue = () => {
    // if (selectedExitFlowMethod === 1) {
    if (selectedExitFlowMethod === 0) {
      console.log("inside if");
      // navigate(`${pageRouteConstants.userExitFlow}/${selectedUserId}`);
      navigate(`/exitFlow/${selectedUserId}`);
    }
    setShowDeActivateOptions(false);
  };
  const OnExitFlowPopUpClose = () => {
    setShowDeActivateOptions(false);
    setSelectedUserId("");
  };

  // Method to get the most recently used app name with date
  const getMostRecentAppNameWithDate = (loginDetails: ApplicationInfo[]) => {
    if (!loginDetails || loginDetails.length === 0) return null;

    const mostRecentApp = loginDetails.reduce(
      (latest, current) =>
        new Date(latest.lastLogin) > new Date(current.lastLogin)
          ? latest
          : current,
      loginDetails[0] // Provide the first element as the initial value
    );

    const formattedDate = formatDate(mostRecentApp.lastLogin);
    let mostRecentAppDetail: ApplicationInfo = {
      appName: mostRecentApp.appName,
      lastLogin: formattedDate,
      appId: mostRecentApp.appId,
      authMethod: mostRecentApp.authMethod,
    };

    return mostRecentAppDetail;
  };
  const apps = JSON.parse(
    readFromLocalStorage(
      "applications"
    ) || "[]"
  );

  // Helper to check if Salesmate apps exist
  const isSalesmateApp =
    Array.isArray(apps) &&
    (apps.some((app) =>
      [
        "salesmate-app",
        "salesmate-asa-app",
      ].includes(app)
    ) ||
      apps.some((app) =>
        [
          "salesmate-app",
          "salesmate-asa-app",
        ].includes(
          app.applicationName
        )
      ));
  return (
    <>
      <div className="block lg:hidden">
        <StaffListAndroid
          title={statusKey ? statusMap[statusKey] : t("EmployeeList")}
          staffList={staffListData}
          pendingStaff={pendingStaff}
          setShowApprovedPopUp={setShowApprovedPopUp}
          setShow={setShow}
          showApprovedPopUp={showApprovedPopUp}
          show={show}
          popUpMsg={popUpMsg}
          approveUser={approveUser}
          rejectUser={rejectUser}
          handelRowsPerPagechange={handelRowsPerPagechange}
          handlePageNumberChange={handlePageNumberChange}
          handleNextPage={handleNextPage}
          handlePrevPage={handlePrevPage}
          currentPage={currentPage}
          totalPages={totalPages}
          rowsPerPageValue={rowsPerPageValue}
          pageNumber={pageNumber}
          key={statusKey}
          showErrorMessage={showErrorMessage}
          isEkycVerified={isEkycVerified}
          getMostRecentAppNameWithDate={getMostRecentAppNameWithDate}
          updateUserStatus={updateUserStatus}
          handleDeactivateButton={handleDeactivateButton}
          routeUrl={routeUrl}
          selectedExitFlowMethod={selectedExitFlowMethod}
          setSelectedExitFLowMethod={setSelectedExitFLowMethod}
          OnExitFlowPopUpContinue={OnExitFlowPopUpContinue}
          OnExitFlowPopUpClose={OnExitFlowPopUpClose}
          rowPerPageArray={rowPerPageArray}
          deleteUserStatus={deleteUserStatus}
          updateStatus={updateStatus}
          rejectButtonClicked={rejectButtonClicked}
          showDeActivateOptions={showDeActivateOptions}
          closeModal={closeModal}
          errorMsg={errorMsg}
          errorDeleteMsg={errorDeleteMsg}
          errorMsgStatus={errorMsgStatus}
          isSalesmateApp={isSalesmateApp}
        />
      </div>
      <div className=" hidden lg:block">
        <div className="bg-whiteColor rounded-lg drop-shadow-lg text-white  pb-10">
          <div className="flex flex-col">
            <div className="p-6 title1 text-StaffListHeaderColor  w-full ">
              <div className="flex  justify-between">
                <div className="flex items-center">
                  <div>
                    {statusKey ? statusMap[statusKey] : isStaffListPage ? t("EmployeeList") : t('latestEmployeeList')}
                  </div>
                  <div className="quickLinksDescription text-primary bg-sideMenubackground border border-hoverButton rounded-3xl ml-3 h-[22px] w-24 flex justify-center items-center">
                    {`${staffListData?.staffList?.totalCount || 0} ${t(
                      "members"
                    )}`}
                  </div>
                </div>
                {/* <div className="mt-4  flex items-center justify-between "> */}
                <div className=" flex items-center">
                  <div className="pr-6">
                    <SearchBar from="Staff"/>
                  </div>
                  <div className="pr-2">
                    <DownloadBar />
                  </div>
                  <div className="pr-2">
                    <FilterBar />
                  </div>
                  <div className="pr-6">
                    <SortBar />
                  </div>
                </div>
                {/* <div className="flex items-center">
              <div className="buttonText ">
                <Button
                  handleClick={() => {
                    navigate("/onboard");
                  }}
                  buttonText={" Add User +"}
                  className={ButtonStyles2}
                />
              </div>
              <div className="flex items-center mt-3">
                <div className="buttonText ml-9 mr-2 ">
                  {StafflistConstants.Sortby}
                </div>
                <DropdownIcon />
              </div>

              <div className="ml-7 mt-4">
                <FilterIcon />
              </div>
              </div> */}
                {/* </div> */}
              </div>
              <div className=" overflow-hidden overflow-y-auto scrollbar-hide ">
                {pendingStaff.loading ? (
                  <Loader />
                ) : (
                  <table className=" min-w-full mt-6">
                    <thead className="bg-sideMenubackground rounded-lg text-black  h-[72px] ">
                      <tr>
                        <th className=" staffListHeader w-1/8 text-start pl-8 ">
                          {t("StaffName")}
                        </th>
                        <th className=" w-1/8 ">
                          <div className="flex ">
                            <div className="staffListHeader">
                              {t("Baserole")}
                            </div>
                            <StaffListDropDownIcon />
                          </div>
                        </th>
                        <th className=" w-1/8 pl-1">
                          <div className="flex ">
                            <div className="staffListHeader">
                              {t("CreatedDate")}
                            </div>
                            <StaffListDropDownIcon />
                          </div>
                        </th>
                        {!isSalesmateApp &&
                        <th className=" w-1/8  ">
                          <div className="flex ">
                            <div className="staffListHeader">
                              {t("UserValidation")}
                            </div>
                            <StaffListDropDownIcon />
                          </div>
                        </th>
                      }
                        {/* 
                  <th className=" text2 w-1/12">
                    {Constants.AdhaarAuthentication}
                  </th> */}
                  {!isSalesmateApp &&
                        <th className=" staffListHeader w-1/8    ">
                          {t("Roles")}
                        </th>}
                        <th className=" staffListHeader w-1/8 ">{t("Last")}</th>
                        <th className=" w-1/8 ">
                          <div className="flex ">
                            <div className="staffListHeader">{t("Status")}</div>
                            <StaffListDropDownIcon />
                          </div>
                        </th>
                        <th className=" w-1/8 ">
                          <div className="flex ">
                            <div className="staffListHeader">
                              {t("Actions")}
                            </div>
                            <StaffListDropDownIcon />
                          </div>
                        </th>
                      </tr>
                    </thead>

                    {!showErrorMessage && (
                      <tbody className="bg-whiteColor">
                        {staffListData?.staffList?.data?.map(
                          (data: any, index: any) => {
                            let hideAction =
                              data?.id.toString() ===
                              readFromLocalStorage("userId")
                                ? true
                                : false;
                            let userValidationStatus = getUserValidationStatus(
                              data?.consentStatus,
                              data?.ekycStatus
                            );
                            let ekycVerifiedStatus = isEkycVerified(
                              data?.ekycStatus,
                              data?.consentStatus,
                              data?.isEkycEnabled
                            );                           
                            const mostRecentAppDetail: ApplicationInfo | null =
                              getMostRecentAppNameWithDate(data?.loginDetails);
                            return (
                              <tr
                                data-testid="staff-row"
                                key={index}
                                className="cursor-pointer border-b border-dividerColor"
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent event bubbling
                                  dispatch(resetCameraError());
                                  const apps = JSON.parse(
                                    readFromLocalStorage("applications") || "[]"
                                  );
                                  // If apps is array of strings
                                  if (
                                    Array.isArray(apps) &&
                                    apps.some((app) =>
                                      [
                                        "salesmate-app",
                                        "salesmate-asa-app",
                                      ].includes(app)
                                    )
                                  ) {
                                    console.log(
                                      "Navigation disabled for Salesmate users"
                                    );
                                    return; // do nothing
                                  }

                                  // If apps is array of objects: [{ applicationName: "salesmate-app" }]
                                  if (
                                    Array.isArray(apps) &&
                                    apps.some((app) =>
                                      [
                                        "salesmate-app",
                                        "salesmate-asa-app",
                                      ].includes(app.applicationName)
                                    )
                                  ) {
                                    console.log(
                                      "Navigation disabled for Salesmate users"
                                    );
                                    return; // do nothing
                                  }

                                  // ✅ proceed if allowed
                                  console.log("Navigating to:", data?.id);
                                  writeToLocalStorage(
                                    "userDetailActiveTabIndex",
                                    0
                                  );
                                  writeToLocalStorage("UId", data?.id);
                                  navigate(`/StaffDetail/${data?.id}`);
                                }}
                              >
                                <td className="py-4">
                                  <div className="items-center justify-start pl-4 flex">
                                    <div className="mr-2">
                                      <div>
                                        {data?.profilePhotoUrl ? (
                                          <img
                                            className="h-10 w-10 rounded-full object-cover"
                                            src={data.profilePhotoUrl}
                                            alt="profile photo"
                                          />
                                        ) : (
                                          <ProfileIcon />
                                        )}
                                      </div>
                                    </div>
                                    <div>
                                      <div className="staffListHeader text-primary">
                                        {data?.firstName}
                                      </div>
                                      <div className="smallText mt-1 text-inputTextColor">
                                        {data?.primaryPhoneNumber}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="quickLinksDescription text-start text-inputTextColor">
                                    {data?.baseRoles?.map(
                                      (roleData: any, index: number) => {
                                        return (
                                          <div key={index}>
                                            {roleData?.role?.name}
                                            {index !==
                                              data.baseRoles.length - 1 && ","}
                                          </div>
                                        );
                                      }
                                    )}
                                    {data?.professionalDetails?.employeeId && (
                                      
                                         <div className="smallText text-inputTextColor">
                                            {DashboardConstants?.empId}
                                            {data?.professionalDetails?.employeeId}
                                          </div>
                                      
                                    )}
                                    {data?.id && (
                                     
                                         <div className="smallText text-inputTextColor">
                                         {DashboardConstants?.UId}
                                          {data?.id}
                                          </div>
                                      
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <div className=" quickLinksDescription text-inputTextColor text-start">
                                    {getFormattedDate(data?.createdAt)}
                                  </div>
                                </td>
                                {!isSalesmateApp &&
                                <td>
                                  <div
                                    className={`flex  border-b rounded-lg p-2 w-fit ${userValidationStatus.backGroundColor} gap-2 `}
                                  >
                                    {userValidationStatus.icon}
                                    <div
                                      className={`smallText text-black font-nunito mt-1`}
                                    >
                                      {userValidationStatus.status}
                                    </div>
                                  </div>
                                </td>
                          }
                                {!isSalesmateApp && 
                                <td>
                                  <div
                                    data-testId="addrole"
                                    onClick={(e) => {
                                      e.stopPropagation();

                                      // Stop the event from propagating to the checkbox
                                      dispatch(saveActiveTabIndex(2));
                                      navigate(`/StaffDetail/${data?.id}`);
                                    }}
                                  >
                                    <div className="flex justify-center">
                                      <AddIcon />
                                      <div className="staffListHeader text-center pl-2 text-primary">
                                        {t("add")}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                          }
                                <td>
                                  {mostRecentAppDetail != null ? (
                                    <div className="text-center flex-col">
                                      <div className="quickLinksDescription text-inputTextColor">
                                        {mostRecentAppDetail?.appName}
                                      </div>
                                      <div className="smallText mt-1 text-inputTextColor">
                                        {getFormattedDate(
                                          mostRecentAppDetail?.lastLogin
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="text-center">---</div>
                                  )}
                                </td>
                                <td>
                                  <div className=" flex justify-start   ">
                                    <div
                                      className={`
                                        quickLinksDescription text-whiteColor rounded w-fit px-3 py-[6px]
                                        ${statusClassMap[data?.status]}
                                      `}
                                    >
                                     {userStatus[data?.status]}
                                </div>
                                  </div>
                                </td>

                                <td onClick={(e) => e.stopPropagation()}>
                                  <div className="flex items-center justify-start">
                                    <div className="flex justify-center gap-4">
                                      {(data?.status === UserStatus.PENDING ||
                                        data?.status ===
                                          UserStatus.PASSIVE ) && (
                                        <button
                                          data-testId="approveUser"
                                          className={` ${
                                            ekycVerifiedStatus || isSalesmateApp
                                              ? "has-tooltip"
                                              : "cursor-not-allowed"
                                          }`}
                                          disabled={!ekycVerifiedStatus && !isSalesmateApp} // Disable button if not verified
                                          onClick={() => {
                                            if (ekycVerifiedStatus || isSalesmateApp) {
                                              updateUserStatus(
                                                data?.status ===
                                                  UserStatus.PASSIVE 
                                                  ? UserStatusAction.ACTIVATE
                                                  : Constants.AcceptUser,
                                                data?.id
                                              );
                                            }
                                          }}
                                        >
                                          <span className="tooltip relative text-xs rounded-lg px-5 py-2 bg-white text-black staffListDownloadCheckbox mt-10">
                                            <div className="absolute bottom-[-15px] left-9 z-100">
                                              <TooltipIcon />
                                            </div>
                                            {data?.status === UserStatus.PASSIVE
                                              ? t("ActivateUser")
                                              : t("AcceptUser")}
                                          </span>
                                          <ApproveIcon
                                            bgColor={
                                              ekycVerifiedStatus || isSalesmateApp
                                                ? "#ECF5EE"
                                                : "#F4F4F4"
                                            }
                                            iconColor={
                                              ekycVerifiedStatus || isSalesmateApp
                                                ? "#449F52"
                                                : "#B3B3B3"
                                            }
                                          />
                                        </button>
                                      )}

                                      {data?.status === UserStatus.PENDING && (
                                        <button
                                          data-testid="rejectUser"
                                          className="has-tooltip"
                                          onClick={() =>
                                            updateUserStatus(
                                              Constants.RejectUser,
                                              data?.id
                                            )
                                          }
                                        >
                                          <span className="tooltip relative text-xs rounded-lg px-5 py-2 bg-white text-black staffListDownloadCheckbox mt-10">
                                            <div className="absolute bottom-[-15px] left-9 z-100">
                                              <TooltipIcon />
                                            </div>
                                            {t("UserReject")}
                                          </span>
                                          <RejectIcon />
                                        </button>
                                      )}

                                      {data?.status !== UserStatus.INACTIVE &&
                                        data?.status !== UserStatus.PENDING &&
                                        (hideAction ? (
                                          <td>
                                            <div className="body2 text-center">
                                              --
                                            </div>
                                          </td>
                                        ) : (
                                          <button
                                            data-testid="deactivateUser"
                                            className="has-tooltip rounded-lg  py-2"
                                            onClick={() =>
                                              handleDeactivateButton(data?.id)
                                            }
                                          >
                                            <span className="tooltip relative text-xs bg-white text-black staffListDownloadCheckbox mt-10">
                                              <div className="absolute bottom-[-15px] left-9 z-100">
                                                <TooltipIcon />
                                              </div>
                                              {t("deactivateUser")}
                                            </span>
                                            <DeactivateIcon />
                                          </button>
                                        ))}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )}
                      </tbody>
                    )}
                  </table>
                )}
                {showErrorMessage && (
                  <div className="">
                    <div
                      className="bg-red-100 border border-red-400 text-red-700 py-2 px-4 text-center rounded relative mt-5"
                      role="alert"
                    >
                      <span className="block sm:inline">
                        {t("noMoreDataToShow")}
                      </span>
                    </div>
                  </div>
                )}
                <StaffListPopups
                  updateStatus={updateStatus}
                  deleteUserStatus={deleteUserStatus}
                  STATUS={STATUS}
                  show={show}
                  approveButtonClicked={approveButtonClicked}
                  popUpMsg={popUpMsg}
                  approveUser={approveUser}
                  closeModal={closeModal}
                  rejectButtonClicked={rejectButtonClicked}
                  rejectUser={rejectUser}
                  showApprovedPopUp={showApprovedPopUp}
                  errorMsg={errorMsg}
                  errorDeleteMsg={errorDeleteMsg}
                  currentPage={currentPage}
                  rowsPerPageValue={rowsPerPageValue}
                  keyVal={statusKey}
                  errorMsgStatus={errorMsgStatus}
                  StaffListConstants={StaffListConstants}
                  fetchStaffListAsync={fetchStaffListAsync}
                />
                {showDeActivateOptions && (
                  <PopUpModelForStaffExitFlow
                    selectedExitFlowMethod={selectedExitFlowMethod}
                    setSelectedExitFLowMethod={setSelectedExitFLowMethod}
                    OnExitFlowPopUpContinue={OnExitFlowPopUpContinue}
                    OnExitFlowPopUpClose={OnExitFlowPopUpClose}
                  />
                )}
              </div>
            </div>
            {routeUrl[1] !== "dashboard" && (
                  <div className="bg-sideMenubackground rounded-lg py-3">
                    <div className="flex justify-between pr-8 pl-4">
                      <div className="flex items-center">
                        <div className="staffListDownloadCheckbox text-popUpTitleColor">
                          {t("rowsPerPage")}
                        </div>
                        <div className="flex flex-row text-black">
                          <div className="py-1 pl-2 mr-2 text-black ">
                            <select
                              id="rowPerpage"
                              onChange={handelRowsPerPagechange}
                              className="py-2 pl-2 pr-1 text-inputTextColor border border-hoverButton rounded-lg bg-whiteColor staffListHeader"
                            >
                              <option selected className="hidden">
                                {rowsPerPageValue}
                              </option>
                              <option value="10">{rowPerPageArray[0]}</option>
                              <option value="20">{rowPerPageArray[1]}</option>
                              <option value="30">{rowPerPageArray[2]}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="pt-2.5">
                        <div className="flex items-center staffListDownloadCheckbox text-popUpTitleColor">
                          {t("page")}
                          <div className="px-2">
                            <div>
                            <input type="text" id="number-of-pages" className="bg-whiteColor border border-hoverButton text-inputTextColor staffListHeader rounded-sm   p-2  w-6 h-6" 
                        //  placeholder={pageNumber} 
                         value={currentPage}
                         onChange={(e) => {
                          handlePageNumberChange(e);
                        }}
                         />
                            </div>
                          </div>
                          <div>
                            {" "}
                            {t("of")} {totalPages}
                          </div>
                        </div>
                      </div>
                      
                      <div className="flex items-center">
                      {totalPages > 1 && currentPage !== 1 &&(
                         <div className=" flex border border-primary px-2 py-1 rounded-lg bg-sideMenubackground">
                          <button
                            disabled={currentPage === 1}
                            onClick={handlePrevPage}
                            style={{
                              fontSize: "13px",
                              color: "#183883",
                              fontWeight: "400",
                            }}
                          >
                            {t("Previous")}
                          </button>
                        </div>
                      )}
                      {totalPages > 1 && currentPage !== totalPages &&(
                        <div className="pl-4">
                          <div className=" flex border border-black px-2 py-1 rounded-lg bg-primary ">
                            <button
                              disabled={currentPage === totalPages}
                              onClick={handleNextPage}
                              style={{
                                fontSize: "13px",
                                color: "#FFF",
                                fontWeight: "400",
                              }}
                            >
                              {t("Next")}
                            </button>
                          </div>
                        </div>
                          )}
                      </div>
                    
                    </div>
                  </div>
                )}
          </div>
        </div>
      </div>
    </>
  );
};

export default StaffListComponent;
